import Map from './Map';
import Hero from './Hero';
import Facts from './Facts';
import Music from './Music';
import Anchor from './Anchor';
import Design from './Design';
import Descriptive from './Descriptive';
import TitleAndText from './TitleAndText';
import CallToAction from './CallToAction';
import MultiTypeList from './MultiTypeList';
import InterestingFact from './InterestingFact';
import AbstractMouseEffect from './AbstractMouseEffect';
import LinearSliderGallery from './LinearSliderGallery';
import DescriptiveSecondary from './DescriptiveSecondary';
import HighlightedTextSection from './HighlightedTextSection';
import InformativeSliderGallery from './InformativeSliderGallery';
import CardsEffectSliderGallery from './CardsEffectSliderGallery';
import InformativeSliderGallerySecondary from './InformativeSliderGallerySecondary';

//! Landing
import Faq from './LandingAccordion';
import FormSection from './FormSection';
import Partners from './LandingPartners';

export { Map, Faq, Hero, Facts, Music, Design, Anchor, Partners, Descriptive, TitleAndText, CallToAction, MultiTypeList, InterestingFact, LinearSliderGallery, AbstractMouseEffect, DescriptiveSecondary, HighlightedTextSection, InformativeSliderGallery, CardsEffectSliderGallery, InformativeSliderGallerySecondary, FormSection };
